(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-product-with-image"] && !Shopify.designMode) return;
  try {
    
class YGProductWithImage extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
        this.mainSwiper = null;
      }
      if (this.imageSwiper) {
        this.imageSwiper.destroy(true, true);
        this.imageSwiper = null;
      }
    }

    initSwiper() {
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');
      const pagination = this.querySelector('.swiper-pagination');
      const mainSwiperEl = this.querySelector('.yg-product-cards');
      const imageSwiperEl = this.querySelector('.yg-product-image');

      // 创建主 Swiper（产品卡片）
      this.mainSwiper = new Swiper(mainSwiperEl, {
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          100: {
            spaceBetween: 20,
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      });

      // 创建图像 Swiper
      this.imageSwiper = new Swiper(imageSwiperEl, {
        slidesPerView: 1,
        allowTouchMove: false, // 禁止手动滑动
      });

      // 同步两个 Swiper
      this.mainSwiper.on('slideChangeTransitionStart', () => {
        this.imageSwiper.slideToLoop(this.mainSwiper.realIndex, 300);
      });

      this.imageSwiper.on('slideChangeTransitionStart', () => {
        this.mainSwiper.slideToLoop(this.imageSwiper.realIndex, 300);
      });
    }
  }

  if (!window.customElements.get('yg-product-with-image')) {
    window.customElements.define('yg-product-with-image', YGProductWithImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-reviews"] && !Shopify.designMode) return;
  try {
    
  class YGReviewSwiper extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');
      this.swiperInstance = new Swiper(this, {
        // navigation: {
        //   nextEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-next'),
        //   prevEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-prev'),
        // },
        breakpoints: {
          100: {
            spaceBetween: 12,
            slidesPerView: 1,
          },
          968: {
            spaceBetween: 12,
            slidesPerView: 2,
          }
        },
        navigation: {
          //navigation: 配置轮播的前后导航按钮。
          nextEl: nextEl,
          prevEl: prevEl,
        },
        on: {
          init: e => {
            if (e.passedParams.loop && e.slides.length < 5) {
              e.slides.forEach(slide => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              })
            }
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-review-swiper')) {
    window.customElements.define('yg-review-swiper', YGReviewSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-template-1"] && !Shopify.designMode) return;
  try {
    
  class YGTest extends YGUtils {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      // 这里放置自定义逻辑
      this.test({
        text: '123',
      });
    }
  }
  if (!window.customElements.get('yg-test')) {
    window.customElements.define('yg-test', YGTest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video"] && !Shopify.designMode) return;
  try {
    
  class IconCarousel extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.init());
    }

    init() {
      const track = this.querySelector(".carousel-blocks");
      if (!track) return;

      const iconCount = parseInt(getComputedStyle(track).getPropertyValue("--icon-count"));
      const blocks = track.querySelectorAll(".carousel-block");

      if (blocks.length < iconCount) return;

      // 计算第一套实际宽度
      let set1Width = 0;
      for (let i = 0; i < iconCount; i++) {
        set1Width += blocks[i].offsetWidth + 12;
      }

      track.style.setProperty("--shift", `-${set1Width}px`);
    }
  }

  customElements.define("icon-carousel", IconCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-videos-popup"] && !Shopify.designMode) return;
  try {
    
  class YGVideoPopup extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');
      this.swiperInstance = new Swiper(this, {
        // navigation: {
        //   nextEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-next'),
        //   prevEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-prev'),
        // },
        breakpoints: {
          100: {
            spaceBetween: 12,
            slidesPerView: 1,
          },
          700: {
            spaceBetween: 12,
            slidesPerView: 2,
          },
          1000:{
            spaceBetween: 12,
            slidesPerView: 4,
          }
        },
        navigation: {
          //navigation: 配置轮播的前后导航按钮。
          nextEl: nextEl,
          prevEl: prevEl,
        },
        on: {
          init: e => {
            if (e.passedParams.loop && e.slides.length < 5) {
              e.slides.forEach(slide => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              })
            }
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-video-popup')) {
    window.customElements.define('yg-video-popup', YGVideoPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
